// Todo Adaptive

export enum RenderStatus {
  hidden = 'hidden',
  show = 'show',
}

export interface IComponent {
  code: string;
  version: string;
  isRemote?: boolean;
  meta?: Record<string, any>;
  config?: Record<string, any>;
  component: any;
}
export interface IOptionalConfig {
  expansion?: IComponent[];
  input?: IComponent;
}

export type INavConfig = IComponent;

export enum QuickTypes {
  cmd = 'cmd',
  url = 'url',
  message = 'message',
}

export type ComponentType = 'render' | 'exec';
export type IQuickButton = {
  label: string | IComponent; //As the only key
  isHighlight?: boolean; //Highlight
  isNew?: boolean; //Is it new?
  type?: QuickTypes;
  data?: any;
  func?: (appContext: any, config: IQuickButton) => void;
};

export type IQuickButtonsConfig = IQuickButton[];

export enum ToolTypes {
  cmd = 'cmd',
  url = 'url',
}
export type IToolButton = {
  label: string; //As the only key
  isNew?: boolean; //Is it new?
  isHide?: boolean;
  type?: ToolTypes;
  data?: any;
  icon: string | IComponent;
};

export type IToolPanelConfig = Array<IToolButton>;

export type IAvatarsConfig = Record<string, IComponent | string>;
export interface ILayoutConfig {
  navbar?: INavConfig;
  headerFix?: IComponent;
  input?: IComponent;
  inputExt?: string[];
  quickButtons?: IQuickButtonsConfig;
  messageWrapper?: IComponent;
  avatars?: IAvatarsConfig;
  toolPanel?: IToolPanelConfig;
}
